module.exports = __webpack_public_path__ + "static/media/bell-inactive.b65d086c.svg";